import OfferStatusEnum from '@constants/enums/offer/status';
import OfferWorkflowStatusEnum from '@constants/enums/offer/workflowStatus';
import SDRLabelEnum from '@constants/enums/SDRLabel';

import i18n from '@plugins/i18n';

import { OfferCollection } from '@/models';

export class OfferPmiCollection extends OfferCollection {
    static type = 'OfferPmiCollection';

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                sortable: true
            }),
            this.createHeader('workflow_status', i18n.t('workflow_status'), {
                active: false,
                format: 'enum',
                width: '9rem',
                filterable: this.filter_workflow_status
                    ? {
                          operators: this.getOperators(['eq', 'neq', 'in'])
                      }
                    : false,
                enum: OfferWorkflowStatusEnum,
                enumA11yKey: 'enums.offer_workflow_status',
                enumTypes: {
                    [OfferWorkflowStatusEnum.DRAFT]: 'grey',
                    [OfferWorkflowStatusEnum.LIVE]: 'success'
                }
            }),
            this.createHeader('status', i18n.t('status'), {
                format: 'enum',
                width: '7rem',
                filterable: true,
                sortable: true,
                enum: OfferStatusEnum,
                enumA11yKey: 'enums.offer_status',
                enumTypes: {
                    [OfferStatusEnum.OPEN]: 'info',
                    [OfferStatusEnum.CLOSED]: 'error',
                    [OfferStatusEnum.EVERGREEN]: 'success',
                    [OfferStatusEnum.COMING_SOON]: 'warning'
                }
            }),
            this.createHeader('max_fund_size_details', i18n.t('max_fund_size_details'), {
                format: 'wysiwyg',
                width: '25rem'
            }),
            this.createHeader('fund_structure', i18n.t('structure'), {
                path: 'fund.fund_structure.name',
                width: '10rem'
            }),
            this.createHeader('denomination', i18n.t('fund_denomination'), {
                path: 'fund.denomination',
                width: '10rem'
            }),
            this.createHeader('investment_strategy', i18n.t('investment_strategy'), {
                path: 'fund.investment_strategy.name',
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('close_at', i18n.t('close_at'), {
                format: 'datetime',
                width: '9rem'
            }),
            this.createHeader('min_investment', i18n.t('min_investment'), {
                format: 'money',
                width: '10rem'
            }),
            this.createHeader('sector', i18n.t('investment_sector'), {
                path: 'fund.iht_sector.name',
                width: '12rem'
            }),

            this.createHeader('sdr_label', i18n.t('sdr_label'), {
                format: 'enum',
                filterable: true,
                enum: SDRLabelEnum,
                enumA11yKey: 'enums.sdr_label',
                width: '8rem',
                active: false
            })
        ];
    }

    get default_headers() {
        return [
            'name',
            'status',
            'max_fund_size_details',
            'fund_structure',
            'denomination',
            'investment_strategy',
            'close_at',
            'min_investment',
            'sector'
        ];
    }

    get preset_filters() {
        return {
            ...super.preset_filters,
            tax_status: this.filterOperator('is') + ':PMI',
            single_company: this.filterOperator('is') + ':false'
        };
    }
}

export default OfferPmiCollection;
